import {
  matrixForQuery
} from './matrix'

export const matrix = {
  matrixForQuery
}
